module.exports = __webpack_public_path__ + "media/images/plans/dinner/point-1-63a955aa02b2d7b12ab257ee148cc3cb.jpg";